import { render, staticRenderFns } from "./NewLightDarkSwitch.vue?vue&type=template&id=2d00333c&scoped=true&"
import script from "./NewLightDarkSwitch.vue?vue&type=script&lang=ts&"
export * from "./NewLightDarkSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./NewLightDarkSwitch.vue?vue&type=style&index=0&id=2d00333c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00333c",
  null
  
)

export default component.exports